<template>
  <svg
    :style="compassAngle"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 100 130.2"
    class="c-compass c-selector__compass"
  >
    <path
      d="M50,35.2c24.8,0,45,20.2,45,45s-20.2,45-45,45S5,105,5,80.2S25.2,35.2,50,35.2 M50,30.2c-27.6,0-50,22.4-50,50 s22.4,50,50,50s50-22.4,50-50S77.6,30.2,50,30.2L50,30.2z"
    />
    <path
      d="M50,54.4l14.9,42.1l-11.4-5.1c-1.2-0.6-2.3-1-3.6-1s-2.5,0.5-3.6,1l-11.4,5.1L50,54.4 M50,43.2c-0.8,0-1.5,0.5-1.8,1.4 l-20.4,57.3c-0.3,1.3,0.7,2.4,1.8,2.4c0.4,0,0.7-0.2,1.2-0.4l18-8c0.5-0.2,0.8-0.3,1.2-0.3s0.8,0.1,1.2,0.3l18,8 c0.4,0.2,0.8,0.4,1.2,0.4c1.1,0,2.2-1.1,1.8-2.4L51.8,44.6C51.5,43.6,50.8,43.2,50,43.2L50,43.2z"
    />
    <path
      d="M41.1,0h5.7l8,13.1h0.1V0h4.2v18.9h-5.4L45.3,5.4h-0.1v13.4h-4.2V0z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CompassArrow',
  props: {
    rotation: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    compassAngle() {
      return {
        '--rotation': this.rotation + 'deg',
      };
    },
  },
};
</script>

<style lang="scss">
.c-selector__compass {
  position: absolute;
  bottom: 2em;
  right: 2em;
  width: 3em;
  max-width: 10%;
}

.c-compass {
  fill: $g-color-light;
  transform: rotate(var(--rotation));
  background: rgba($g-color-dark, 0.5);
  box-shadow: 0 0 30px 30px rgba($g-color-dark, 0.5);
  border-radius: 100px;
}
</style>